/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */

export const GET_PLAN_TYPE_DATA_GCL = 'GET_PLAN_TYPE_DATA_GCL';
export const SELECTION_TYPE_OPTIONS = 'SELECTION_TYPE_OPTIONS';
export const ERROR_MESSAGES_GCL = 'ERROR_MESSAGES_GCL';
export const GET_ALL_TEMPLATE_TYPE = 'GET_ALL_TEMPLATE_TYPE';
export const GET_QUARTER_VALUE_GCL = 'GET_QUARTER_VALUE_GCL';
export const GET_QUARTER_GENERATE_COLLECTION_LETTER =
  'GET_QUARTER_GENERATE_COLLECTION_LETTER';
export const GET_GCL_DATA = 'GET_GCL_DATA';
export const GET_GCL_DETAIL_PAGE_DATA = 'GET_GCL_DETAIL_PAGE_DATA';
export const GET_GCL_DETAIL_PAGE_DATA_LIST = 'GET_GCL_DETAIL_PAGE_DATA_LIST';
export const SAVE_GCL_DATA = 'SAVE_GCL_DATA';
export const SEND_GCL_DATA = 'SEND_GCL_DATA';
export const GET_GCL_PDF_DATA = 'GET_GCL_PDF_DATA';
export const GET_GCL_EXTRA_STATE = 'GET_GCL_EXTRA_STATE';
export const FLAG_NAVIGATION = 'FLAG_NAVIGATION';
export const GET_PRIOR_QTR_DATA = 'GET_PRIOR_QTR_DATA';
export const GET_TO_MAIL_ID_GCL = 'GET_TO_MAIL_ID_GCL';
export const GENERATE_COLLECTION_LETTER_CLEAR_REDUX_DATA =
  'GENERATE_COLLECTION_LETTER_CLEAR_REDUX_DATA';
export const GET_FROM_MAIL_ID_COLLECTION_LETTER =
  'GET_FROM_MAIL_ID_COLLECTION_LETTER';
